import { useEffect, useState } from "react";

export function useTurnstileReady() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (window.turnstile) {
      setReady(true);
      return;
    }

    const id = setInterval(() => {
      if (window.turnstile) {
        setReady(true);
        clearInterval(id);
      }
    }, 50);

    return () => clearInterval(id);
  }, []);

  return ready;
}
